import PubSub from 'underpub-js';
import gsap from 'gsap';

var Hamburger = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'el-Hamburger',
    isOpen: false,
  };

  $.extend(true, this.options, options);
};

Hamburger.prototype.init = function() {
  var self = this;

  self.$icon = self.options.$el.find(`.${self.data.baseClass}__icon`);
  self.$text = self.options.$el.find(`.${self.data.baseClass}__text`);

  PubSub.subscribe('resizeWidth', () => self.closeHamburger());
  self.initAnimation();
};

Hamburger.prototype.generateHamburgerTL = function() {
  const self = this;
  const $line = self.$icon.find('.line');
  const $top = self.$icon.find('.top');
  const $topLine = $top.find($line);
  const $middle = self.$icon.find('.middle');
  const $middleLine = $top.find($line);
  const $bottom = self.$icon.find('.bottom');
  const $bottomLine = $bottom.find($line);

  const tl = gsap
    .timeline()
    .to(self.$text, {
      duration: 0.3,
      ease: 'expo.out',
      opacity: 0,
      x: -10,
      skewX: -70,
    })
    .to(
      [$top, $bottom, $middle],
      {
        duration: 0.2,
        ease: 'expo.out',
        top: '50%',
        y: '-50%',
        bottom: 'auto',
      },
      '<',
    )
    .to(
      $middle,
      {
        duration: 0.2,
        ease: 'expo.out',
        opacity: 0,
      },
      '<',
    )

    .set($line, {
      backgroundColor: '#003764',
    })
    .set([$top, $bottom], {
      width: '110%',
      xPercent: -5,
    })
    .to($topLine, {
      duration: 0.3,
      ease: 'expo.out',
      rotation: 45,
    })
    .to(
      $bottomLine,
      {
        duration: 0.3,
        ease: 'expo.out',
        rotation: -45,
      },
      '<',
    );

  return tl;
};

Hamburger.prototype.initAnimation = function() {
  const self = this;

  self.animationTL = gsap
    .timeline({
      paused: true,
      reversed: true,
      onStart: () => self.toggleHamburgerState(),
      onReverseComplete: () => self.toggleHamburgerState(),
    })
    .add(self.generateHamburgerTL());

  self.options.$el.on('click', () => self.toggleHamburger());
};

Hamburger.prototype.toggleHamburgerState = function() {
  const self = this;

  self.data.isOpen = !self.data.isOpen;
};

Hamburger.prototype.openHamburger = function(speed = 1) {
  const self = this;

  if (self.data.isOpen || self.animationTL.isActive()) return;

  PubSub.publish('openMobileNav');
  self.animationTL.timeScale(speed).play();
};

Hamburger.prototype.closeHamburger = function(speed = 1.5) {
  const self = this;

  if (!self.data.isOpen || self.animationTL.isActive()) return;

  PubSub.publish('closeMobileNav');
  self.animationTL.timeScale(speed).reverse();
};

Hamburger.prototype.toggleHamburger = function() {
  const self = this;

  self.animationTL.reversed() ? self.openHamburger() : self.closeHamburger();
};

export default Hamburger;
